// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1f29a01d","239":"a597ea69","455":"09674650","762":"f724edba"}[chunkId] + ".chunk.js";
};